import { apiClient } from './client';

export interface Price {
    id: string;
    variantId: string;
    amount: number;
    currency: string;
    interval: 'month' | 'year';
    billing_interval?: 'month' | 'year';
    isActive: boolean;
    offer?: string;
    trialDays?: number;
    isDefault?: boolean;
    providerId?: string;
    metadata?: any;
}

export interface ProductVariant {
    id: string;
    productId: string;
    country: string;
    currency: string;
    name?: string;
    description?: string;
    prices: Price[];
    isActive: boolean;
    slogan?: string;
    displayOrder?: number;
    isHighlighted: boolean;
    highlightText?: string;
    marketingFeatures?: string; // JSON string
}

export type PlatformKey = 'website' | 'shopify';

export interface Product {
    id: string;
    name: string;
    description?: string;
    isActive: boolean;
    isDefault?: boolean;
    availableOn?: PlatformKey[];
    variants?: ProductVariant[];
    metadata?: any;
    subscriberCount?: number;
    _count?: {
        subscriptions: number;
    };
    createdAt: string;
}

export const productsApi = {
    list: async (): Promise<Product[]> => {
        const res = await apiClient.get('/admin/plans');
        return res.data.data;
    },

    get: async (id: string): Promise<Product> => {
        const res = await apiClient.get(`/admin/plans/${id}`);
        return res.data.data;
    },

    create: async (data: Partial<Product>): Promise<Product> => {
        const res = await apiClient.post('/admin/plans', data);
        return res.data.data;
    },

    update: async (id: string, data: Partial<Product>): Promise<Product> => {
        const res = await apiClient.put(`/admin/plans/${id}`, data);
        return res.data.data;
    },

    duplicate: async (id: string, name?: string): Promise<Product> => {
        const res = await apiClient.post(`/admin/plans/${id}/duplicate`, { name });
        return res.data.data;
    },

    delete: async (id: string): Promise<void> => {
        await apiClient.delete(`/admin/plans/${id}`);
    },

    // Variant Methods
    upsertVariant: async (productId: string, data: { country: string, currency: string }): Promise<ProductVariant> => {
        const res = await apiClient.post(`/admin/plans/${productId}/variants`, data);
        return res.data.data;
    },

    addPrice: async (variantId: string, data: Partial<Price>): Promise<Price> => {
        const res = await apiClient.post(`/admin/plans/variants/${variantId}/prices`, data);
        return res.data.data;
    },

    deletePrice: async (priceId: string): Promise<void> => {
        await apiClient.delete(`/admin/plans/prices/${priceId}`);
    },

    deleteVariant: async (variantId: string): Promise<void> => {
        await apiClient.delete(`/admin/plans/variants/${variantId}`);
    }
};
